import Vue from 'vue'
import { ValidationProvider, ValidationObserver, configure } from 'vee-validate'

import './messages'
import './rules'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

configure({
  classes: {
    invalid: 'invalid'
  }
})

/**
 *
 * @param {*} errors { email: ['msg1', 'msg2'], password: ['msg3'], ... }
 * @returns ['msg1', 'msg2', 'msg3', ...]
 */
const getAllErrorMessages = (errors) => {
  if (!errors) return
  const fields = Object.keys(errors)
  return fields.reduce((arr, cur) => {
    return arr.concat(errors[cur])
  }, [])
}

/**
 *
 * @param {*} errors { email: ['msg1', 'msg2'], password: ['msg3'], ... }
 * @returns 'msg1'
 */
export const getFirstErrorMessage = (errors) => {
  if (!errors) return
  return getAllErrorMessages(errors)[0]
}
